import './WhatsNew.css';

/**
 * Release notes on the sign-in page.
 *
 * Deliberately only here: it is the one screen a returning user always passes
 * through, and it keeps announcements out of the editor. Newest entry first —
 * to add one, put it at the top of this array and drop the `isNew` flag from
 * the entry below it.
 */
interface Entry {
  title: string;
  body: string;
  /** Anchor in the user guide (backend/guide/templates/guide/index.html). */
  href: string;
  linkText: string;
  isNew?: boolean;
}

const ENTRIES: Entry[] = [
  {
    title: 'An AI assistant for finding footage and cutting',
    // Says "staff accounts" up front on purpose: this page is the sign-in
    // screen, so most people reading it cannot use the feature. Announcing it
    // without that line would send them hunting for a button that is not there.
    body:
      'Staff accounts can now ask an assistant, in the project chat, to search the archives ' +
      'and edit the timeline — “find shots of the monsoon”, “cut those three together with ' +
      'crossfades”. It proposes changes for you to review, and nothing lands on the timeline ' +
      'until you accept it. Everything it does is visible to everyone in the project.',
    href: '/guide#assistant',
    linkText: 'How the assistant works',
    isNew: true,
  },
  {
    title: 'Edit together, in real time',
    body:
      'Share a link and cut with other people at the same time. You can see who else is in ' +
      'the project and where they are working, and talk it through in a chat that stays with ' +
      'the project.',
    href: '/guide#collab',
    linkText: 'How collaboration works',
  },
  {
    title: 'Import a pan.do/ra edit',
    body:
      "Already assembled an edit in the archive? Paste its URL and the whole clip sequence " +
      'lands on your timeline, ready for transitions, effects and overlays.',
    href: '/guide#import',
    linkText: 'How importing works',
  },
];

export default function WhatsNew() {
  return (
    <section className="whats-new" aria-labelledby="whats-new-heading">
      <h2 id="whats-new-heading" className="whats-new-heading">
        What&rsquo;s new
      </h2>
      <ul className="whats-new-list">
        {ENTRIES.map((entry) => (
          <li key={entry.href} className="whats-new-item">
            <h3 className="whats-new-title">
              {entry.title}
              {entry.isNew && <span className="whats-new-badge">new</span>}
            </h3>
            <p className="whats-new-body">{entry.body}</p>
            <a className="whats-new-link" href={entry.href} target="_blank" rel="noopener">
              {entry.linkText} &rarr;
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
